export function initInformations(): void {
  const sections = document.querySelectorAll<HTMLElement>(".informations-section");

  if (sections.length === 0) return;

  for (const section of sections) {
    imagesSwitcher(section);
  }
}

function imagesSwitcher(section: HTMLElement): void {
  const images = Array.from(
    section.querySelectorAll<HTMLElement>(".informations-section__image-item"),
  );
  const items = Array.from(section.querySelectorAll<HTMLElement>(".faq__item"));

  // одна картинка на секцию или ни одной — переключать нечего
  if (images.length < 2 || items.length === 0) return;

  const sync = (): void => {
    const opened = items.find((item) => item.classList.contains("--opened"));

    // всё закрыто — оставляем последнюю показанную картинку
    if (!opened) return;

    const active = images.find(
      (image) => image.dataset.imageIndex === opened.dataset.imageIndex,
    );

    // у пункта нет своей картинки или она уже показана
    if (!active || active.classList.contains("--active")) return;

    images.forEach((image) => image.classList.toggle("--active", image === active));
  };

  // класс --opened переключает faq.ts, поэтому следим за самим классом
  const observer = new MutationObserver(sync);
  items.forEach((item) =>
    observer.observe(item, { attributes: true, attributeFilter: ["class"] }),
  );

  sync();
}
